import { IFieldProps } from "types/Organisational";

export const mapDropdownOptions = (field: IFieldProps) =>
  (field.dropdown_values as Array<{ key?: string; label?: string; value: string }> | undefined)?.map((item) => ({
    label: item.key ?? item.label ?? item.value,
    value: item.value,
  })) ?? [];
